import * as Types from './types';
import { actionTypes } from './constants';
import { IBannerSlide, ISliderOptions } from '../types';

export const setSlidesAndOptions = (data: {
    sliderOptions: ISliderOptions;
    slides: IBannerSlide[];
}): Types.ISetFeedDataAction => ({
    type: actionTypes.BANNER_FEED_DATA_UPDATE,
    payload: data
});
